let weightedProviders = []
let rolledProvider

/**
 * Stores the provider weights served by the backend
 * (react_props_three_d_studio -> generationProviderWeights). They are kept in module
 * scope instead of the store so a store reset (resetOpenedModelState) does not drop
 * them and leave the session without weights mid-flight.
 *
 * Weights are relative, they do not have to sum up to 100. Providers without a
 * positive weight never win the draw.
 *
 * @param {Object<string, number>} weights - Weight per provider id.
 */
export const setGenerationProviderWeights = (weights) => {
  weightedProviders = Object.entries(weights || {}).filter(([, weight]) => weight > 0)
}

const rollProvider = () => {
  const totalWeight = weightedProviders.reduce((sum, [, weight]) => sum + weight, 0)
  let threshold = Math.random() * totalWeight

  const match = weightedProviders.find(([, weight]) => {
    threshold -= weight

    return threshold < 0
  })

  return (match || weightedProviders[0])[0]
}

/**
 * Resolves the model generation provider to activate when none is active yet,
 * using a weighted random roll performed once per page load. The roll is lazy so
 * it never runs during SSR - the first call comes from the useActiveModelSchema
 * effect. It is memoized so that a store reset (resetOpenedModelState) keeps the
 * engine assigned on load instead of re-rolling mid-session.
 *
 * @param {string[]} providers - Providers eligible for the current generation action.
 * @returns {string} The rolled provider, or the first eligible one when the rolled
 *   provider is not available for this action and settings combination, or when the
 *   backend configured no weights.
 */
export const resolveInitialGenerationProvider = (providers) => {
  if (rolledProvider === undefined && weightedProviders.length > 0) {
    rolledProvider = rollProvider()
  }

  return providers.includes(rolledProvider) ? rolledProvider : providers[0]
}
